import * as React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor: FillColor;
  className: ClassName;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const TwitterLogoIcon = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    viewBox="0 0 23 19"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M20.2037996,3.77813045 C21.1743034,3.22885514 21.9193583,2.36001376 22.2700566,1.32429538 C21.3625353,1.83235815 20.356246,2.20124415 19.2862583,2.40055069 C18.4288368,1.53846546 17.2078342,1 15.8565723,1 C13.261405,1 11.157931,2.98563361 11.157931,5.43541498 C11.157931,5.78268128 11.1994423,6.12116459 11.2796019,6.44613559 C7.37396815,6.26101697 3.91207511,4.49495837 1.59460361,1.81141407 C1.19022702,2.46676099 0.958336732,3.22885514 0.958336732,4.04162045 C0.958336732,5.57999667 1.78784552,6.93798359 3.0482122,7.73318289 C2.27810741,7.71021197 1.5538081,7.51090543 0.920404061,7.17850266 C0.91968835,7.19741989 0.91968835,7.21566151 0.91968835,7.23457874 C0.91968835,9.38371127 2.53934184,11.1761189 4.68933702,11.5835149 C4.29498038,11.6848573 3.87986813,11.7389065 3.45115737,11.7389065 C3.14841171,11.7389065 2.85425458,11.7112063 2.56725456,11.6598595 C3.16487306,13.4218644 4.9004717,14.7041824 6.95670876,14.73999 C5.34850665,15.9297487 3.32232943,16.6384692 1.12080308,16.6384692 C0.741476366,16.6384692 0.36787534,16.6175252 0,16.5769882 C2.07913981,17.8349841 4.54905771,18.569378 7.20291327,18.569378 C15.8458366,18.569378 20.5716749,11.8105217 20.5716749,5.94955828 C20.5716749,5.7570079 20.5673806,5.56580875 20.5580764,5.37528521 C21.4763333,4.75034098 22.2729194,3.9693296 22.9027449,3.07954414 C22.0603533,3.43221537 21.1542635,3.6707076 20.2037996,3.77813045 Z"
        fill={fillColor}
      />
    </g>
  </svg>
);

TwitterLogoIcon.defaultProps = defaultProps;

export { TwitterLogoIcon };
